export const minimalLoadedItems = ({ currentSlide, perPage, total, }) => {
    const totalItemsWithNextPage = currentSlide + perPage * 2;
    return Math.min(totalItemsWithNextPage, total && total > 0 ? total : totalItemsWithNextPage);
};
export const shouldLoadMore = ({ currentSlide, itemsCount, loading, perPage, total, }) => {
    const canLoadMore = !total || itemsCount < total;
    if (!loading && canLoadMore) {
        return itemsCount < minimalLoadedItems({ currentSlide, perPage, total });
    }
    return false;
};
//# sourceMappingURL=utils.js.map